import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import auth from "../../../providers/Auth.Provider";
import LoadingSpinner from "../../../partials/loading.jsx";
import NewNextOfNext from "./NewItem.jsx";
import { useMutation } from "react-apollo";
import { UPDATE_NEXT_KIN } from "../../../queries/staff.query.js";
import UpdateNextOfNext from "./NewItemUpdate.jsx";
import { toast } from "react-toastify";

const NextOfKin = ({ item }) => {
    // local state
    const [newItem, setNewItem] = useState(false);
    const [active, setActive] = useState(null);
    // get current staff
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { id } = GetToken() && GetAuthenticatedStaff();
    // mutation
    const [updateKinFunc, { loading }] = useMutation(UPDATE_NEXT_KIN, {
        onCompleted: (data) => {
            if (data.UpdateStaffNextOfKin) {
                const { message } = data.UpdateStaffNextOfKin;
                toast.success(message);
                setNewItem(false);
                setActive(null);
            }
        },
    });
    return (
        <>
            <Helmet>
                <title>Staff next of kin | {appName}</title>
            </Helmet>

            <div className="row">
                <div className="col-md-6">
                    <strong style={{ fontSize: "1.3em" }}>Next of Kin</strong>
                </div>
                {item.id === id && !item.nextOfKin && (
                    <div className="col-md-6 text-right fade-in">
                        <button type="type" onClick={() => setNewItem(true)} className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success">
                            <i className="material-icons mx-1">add</i>
                            New Next of kin
                        </button>
                    </div>
                )}
                <div className="col-md-12">
                    <LoadingSpinner loading={loading} />
                </div>
                {item.nextOfKin && !active && (
                    <div className="col-12 fade-in">
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                        <strong>Name:</strong>
                                    </td>
                                    <td>{item.nextOfKin.name}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                        <strong>Mobile:</strong>
                                    </td>
                                    <td>{item.nextOfKin.mobile}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                        <strong>Contact Address:</strong>
                                    </td>
                                    <td>{item.nextOfKin.address}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                        <strong>Relationship to Staff:</strong>
                                    </td>
                                    <td>{item.nextOfKin.relationship}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="row">
                            <div className="col-12">
                                <button
                                    onClick={() => {
                                        setNewItem(false);
                                        setActive(item.nextOfKin);
                                    }}
                                    type="type"
                                    className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success"
                                >
                                    Update Next of kin
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {!item.nextOfKin && !newItem && !active && (
                    <div className="col-12 fade-in margin-top-20">
                        <div className="text-center">
                            <h4>Next of kin not added yet!</h4>
                        </div>
                    </div>
                )}

                {newItem && !active && (
                    <div className="col-12 fade-in">
                        <NewNextOfNext
                            onCancel={() => {
                                setNewItem(false);
                                setActive(null);
                            }}
                            onSubmit={async (model) => {
                                await updateKinFunc({
                                    variables: {
                                        model,
                                        id: item.id,
                                    },
                                });
                            }}
                        />
                    </div>
                )}
                {!newItem && active && (
                    <div className="col-12 fade-in">
                        <UpdateNextOfNext
                            onCancel={() => {
                                setNewItem(false);
                                setActive(null);
                            }}
                            onSubmit={async (model) => {
                                await updateKinFunc({
                                    variables: {
                                        model,
                                        id: item.id,
                                    },
                                });
                            }}
                            current={active}
                        />
                    </div>
                )}
            </div>
        </>
    );
};
export default NextOfKin;
